import { useQuery } from "@tanstack/react-query";

import DataSvc from "../../../services/dataSvc";

const useKeywordAnalysisDetail = (
  locationId: string,
  keywordAnalysisId: string
) => {
  return useQuery(
    ["keywordAnalysisDetail", locationId, keywordAnalysisId],
    async () => {
      return await DataSvc.getKeywordAnalysisDetail(
        locationId,
        keywordAnalysisId
      );
    },
    {
      enabled: !!locationId && !!keywordAnalysisId,
    }
  );
};

export default useKeywordAnalysisDetail;
